import CustomProvider, { CustomContext, CustomConsumer } from './CustomProvider';
import FormattedDate from './FormattedDate';
export { CustomContext, CustomConsumer, FormattedDate };
export type { CustomProviderProps } from './CustomProvider';

export default CustomProvider;
